import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import firebase from 'firebase/app' // what is this?
import 'firebase/auth'
import 'firebase/firestore'
import { firestorePlugin } from 'vuefire'

Vue.use(firestorePlugin)

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  store,
  render: h => h(App),
  created () {
    Vue.prototype.$app = firebase.initializeApp({
      apiKey: 'AIzaSyD7F2MIZt_Whc_bx7T_OcrhLurruO2-38g',
      authDomain: 'txtr-app.firebaseapp.com',
      databaseURL: 'https://txtr-app.firebaseio.com',
      projectId: 'txtr-app',
      storageBucket: 'txtr-app.appspot.com',
      messagingSenderId: '1088251100748',
      appId: '1:1088251100748:web:0cd79d9909bea8337cbee9'
    })
    if (location.hostname === "localhost") { // connect to the local emulator
      //Vue.prototype.$db.settings({host: "localhost:8080",ssl: false})
      firebase.firestore().settings({ host: 'localhost:8080', ssl: false });
      firebase.functions().useFunctionsEmulator('http://localhost:5001')
    }
    Vue.prototype.$db = firebase.firestore()
    // if(window.location.hostname === 'localhost') {
    //   Firebase.firestore().settings({ host: 'localhost:8080', ssl: false });
    //   Firebase.functions().useFunctionsEmulator('http://localhost:5001');
    // }
    firebase.auth().onAuthStateChanged(user => {
      store.dispatch("fetchUser", user)
      if (user) {
        // grab the balance
        // lookup user.uid in ledger collection
      } else {
        // zero out the balance
      }
    })
  }
}).$mount('#app')
